import { render, staticRenderFns } from "./showLook.vue?vue&type=template&id=20667373&scoped=true"
import script from "./showLook.vue?vue&type=script&lang=js"
export * from "./showLook.vue?vue&type=script&lang=js"
import style0 from "./showLook.vue?vue&type=style&index=0&id=20667373&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20667373",
  null
  
)

export default component.exports